import * as React from 'react';
import { useMutation as useMutation$1 } from '@apollo/client';
import { handleError } from './helpers.js';

const useMutation = (mutation, options)=>{
    const [executable, result] = useMutation$1(mutation, options);
    const { error  } = result;
    React.useEffect(()=>{
        if (error) {
            handleError(mutation, error);
        }
    }, [
        error,
        mutation
    ]);
    return [
        executable,
        result
    ];
};

export { useMutation as default };
//# sourceMappingURL=use-mutation.js.map
